import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function CTASection() {
  return (
    <section className="py-20 lg:py-28 bg-slate-900">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* For Organizations */}
          <div className="bg-slate-800/50 rounded-3xl p-8 lg:p-10 border border-slate-700/50">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="w-8 h-[2px] bg-honor-orange" />
              <span className="text-honor-orange text-sm font-medium uppercase tracking-wide">
                Recruteurs
              </span>
            </div>
            
            <h3 className="text-2xl lg:text-3xl font-bold text-white mb-4">
              Vous recrutez ?
            </h3>
            <p className="text-slate-400 text-lg mb-8 leading-relaxed">
              Publiez vos offres gratuitement et touchez les meilleurs talents de Brazzaville.
            </p>
            
            <Link to="/publish-opportunity">
              <Button 
                size="lg" 
                className="bg-honor-orange hover:bg-honor-orange/90 text-white font-semibold"
              >
                Publier une offre
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
          
          {/* For Candidates */}
          <div className="bg-white rounded-3xl p-8 lg:p-10">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="w-8 h-[2px] bg-slate-900" />
              <span className="text-slate-600 text-sm font-medium uppercase tracking-wide">
                Candidats
              </span>
            </div>
            
            <h3 className="text-2xl lg:text-3xl font-bold text-slate-900 mb-4">
              Prêt à postuler ?
            </h3>
            <p className="text-slate-600 text-lg mb-8 leading-relaxed">
              Explorez toutes les opportunités disponibles et trouvez celle qui vous correspond.
            </p>
            
            <Link to="/opportunities">
              <Button 
                size="lg" 
                variant="outline"
                className="border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white font-semibold"
              >
                Voir les opportunités
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
